// v4 (spec-v4-structure-and-stage.md 5.2): something the user must see: an error, a blocker ("Pip needs an approved
// sheet"), a warning (older looks) or a quiet note ("Waiting for your Suno song"). Never inside a fold.
import type { ReactNode } from "react";
import type { NoticeData } from "../nextstep";

export function Notice({ tone, text, code, action }: NoticeData & { action?: ReactNode }) {
  return (
    <div className={`notice notice-${tone}`} role={tone === "error" ? "alert" : "status"} data-code={code}>
      <svg className="notice-icon" width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden focusable="false">
        {tone === "info" ? (
          <>
            <circle cx="12" cy="12" r="8" />
            <path d="M12 11v5M12 8h.01" />
          </>
        ) : (
          <path d="M12 4 21 19H3zM12 10v4M12 16.5h.01" />
        )}
      </svg>
      <span className="notice-text">{text}</span>
      {action && <span className="notice-action">{action}</span>}
    </div>
  );
}
